<template>
  <div class="flex">
    <router-view name="nav" />
    <div class="grow mx-10 mb-10">
      <BusinessHeader />
      <router-view class="mt-4" />
    </div>
  </div>
</template>
<script>
import router from '../../router'
import BusinessHeader from '@/components/business/BusinessHeader.vue'

export default {
  components: {
    BusinessHeader,
  },
  computed: {
    isLogin() {
      return localStorage.getItem('influme_login') !== null
    },
  },
  mounted() {
    if (!this.isLogin) router.push('/home')
  }
}
</script>